import React, { useState } from "react";
import { Toast } from "@t8891/mobile";
import { Button } from "@t8891/pc";
import SuperForm from "@components/InquiryLogistics/SuperForm";
import { useMutation, useQuery } from "react-query";
import { collectDefaultItems, isDisabled, mergeItemIdData, toggleItem } from "utils/InquiryLogistics";
import { fakeInquirySecondInformation, fetchInquirySecondInformation } from "@services/inquiry";
import { useSetState } from "ahooks";
import { IInquirySecondInformationParams, InquirySecondInformation } from "@Types/business";

export interface IFormParams {
  itemId: number;
  [key: string]: any; // 保留其他属性的灵活性
}

const AskSuccessLogistic: React.FC<any> = ({ rosterId, inquiryId }) => {
  const initData: InquirySecondInformation = {
    completed: -1,
    form: {
      title: "完善購車資訊，更好的為您服務",
      description: "",
      fields: [],
    },
  };
  const [formParams, setFormParams] = useState<IFormParams[]>([]);
  const [params, setParams] = useSetState<InquirySecondInformation>(initData);

  const { data = initData } = useQuery<InquirySecondInformation>(
    [`fetchInquirySecondInformation`, inquiryId, rosterId],
    async () => {
      let res = await fetchInquirySecondInformation({ inquiryId, rosterId });
      // res = brandMock;

      let arr = res?.data?.form?.fields;
      if (arr) {
        const resultItems = collectDefaultItems(arr);
        setFormParams(resultItems);
      }
      if (res?.status === 12000) {
        setParams(res.data);
      }

      return res?.status === 12000 ? res.data : initData;
    },
  );
  const { form, completed } = params;

  const mutation = useMutation<void, unknown, IInquirySecondInformationParams>(async (params) => {
    const res = await fakeInquirySecondInformation(params);
    if (res?.status === 12000) {
      setParams(initData);
    } else {
      Toast.show(res.data.content);
    }
  });

  return (
    <>
      {completed === 0 && Object.keys(form).length > 0 && (
        <>
          <div className='w-1100 mx-auto px-16 py-20  rounded-4' style={{ border: "1px solid #E8E8E8" }}>
            <div className='items-center flex justify-center text-15 text-[#333] mb-14'>{form?.title}</div>
            <div className='w-460 mx-auto  grid gap-20'>
              {form?.fields?.length > 0 &&
                form?.fields?.map((item: any, index: number) => (
                  <SuperForm
                    parentItemId={item.itemId}
                    formParams={formParams}
                    onChange={(item, type) => {
                      setFormParams((prevArr) => toggleItem({ prevArr, item, type: type || item.type }));
                    }}
                    item={item}
                    key={index}
                  />
                ))}

              <div className='relative mt-20 w-346'>
                <div className='absolute right-0 -top-30 w-140 h-26 '>
                  <img
                    className='w-full'
                    src={`https://photo.8891.com.tw/2025/03/13/1741828107669856.png`}
                    alt={""}
                    sizes='100vw'
                  />
                </div>

                <Button
                  // disabled={isDisabled({ formParams, data: data.form.fields })}
                  size='large'
                  style={{
                    "--width": "345px",
                    "--height": "40px",
                    "--font-size": "14px",
                    // @ts-ignore
                    "--tc-color-gray-background": "#ddd",
                  }}
                  block
                  round={false}
                  type='primary'
                  onClick={() => {
                    // 防止重复提交
                    if (mutation.isLoading) {
                      Toast.show("請勿重複提交");
                      return;
                    }
                    let arr: { itemId: number; value: any }[] = mergeItemIdData({ formParams });

                    mutation.mutate({
                      inquiryId: inquiryId,
                      rosterId: rosterId,
                      data: arr,
                    });
                  }}
                >
                  確認提交
                </Button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default AskSuccessLogistic;
